var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { Box, Skeleton, Typography, useTheme } from "@mui/material";
// @ts-ignore
import { selectors } from "paul-core-package";
import { memo } from "react";
var energySavingTitle = "ENERGY_SAVING_TITLE";
export var EnergySavingHeader = memo(function () {
    var _a;
    var theme = useTheme();
    var tI = useSelector(selectors.getActiveTranslationsInterfaceUILocalizations);
    return (_jsxs(Box, { children: [_jsx(Box, { sx: {
                    width: "80px",
                    height: "4px",
                    background: theme.palette.grey[300],
                    mb: 4,
                } }), _jsx(Typography, __assign({ variant: "h3", color: theme.palette.primary.dark, sx: { mb: 2 } }, { children: (_a = tI[energySavingTitle]) !== null && _a !== void 0 ? _a : (_jsx(Skeleton, { variant: "text", sx: { fontSize: "inherit", width: 100 } })) }))] }));
});
